import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { soCouponDateRangeState } from "../../store/soCouponDateRangeState";

export const useFetchSoCouponOverallScoresCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: soCouponOverallScoresCount, error, isLoading } = useSWR<number>(`socoupon/overall-scores/count/?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`)
  return { soCouponOverallScoresCount, isLoading, error };
};